import { ModalTarget, type ModalTargetProps } from "../Modal/ModalTarget";

export type DrawerTargetProps = ModalTargetProps & {};

export function DrawerTarget({ ...props }: DrawerTargetProps) {
  return <ModalTarget {...props} />;
}

DrawerTarget.displayName = "Drawer.Target";
